import { formatNumber } from "@angular/common";

export function toKilobytes(sizeBytes: number): number {
  return Number.parseFloat((sizeBytes / 1024).toFixed(2));
}

export function toSizeDisplay(sizeBytes: number): string {
  let curSize: number = sizeBytes;
  const arrSuffixes: string[] = ["bytes", "KB", "MB", "GB"];
  let curSuffix: string = '';
  for (var i = 0; i < arrSuffixes.length; i++){
    curSuffix = arrSuffixes[i];
    if ((curSize / 1024) < 1) {      
      break;
    }    
    curSize /= 1024;
  }
  return `${formatNumber(curSize, 'en-US', '1.0-2')} ${curSuffix}`;
}
